﻿import React, { useState } from "react";
import { Menu } from "lucide-react";
import RevisrSideBar from "./RevisrSideBar";

interface RevisrLayoutProps {
  children: React.ReactNode;
  /** Hides the mobile top bar - use on pages that provide their own mobile toolbar */
  hideMobileBar?: boolean;
}

export default function RevisrLayout({ children, hideMobileBar = false }: RevisrLayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-[calc(100vh-3.5rem)] bg-background">
      {/* Sidebar - static on desktop, drawer on mobile */}
      <RevisrSideBar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Mobile backdrop */}
      {mobileOpen && (
        <div
          className="fixed top-14 bottom-0 inset-x-0 z-40 bg-black/50 md:hidden"
          onClick={() => setMobileOpen(false)}
          data-testid="sidebar-backdrop"
        />
      )}

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Mobile-only top bar with sidebar trigger - hidden on pages with their own toolbar */}
        {!hideMobileBar && (
          <div className="md:hidden flex items-center gap-3 px-4 h-11 bg-background border-b border-border flex-shrink-0">
            <button
              onClick={() => setMobileOpen(true)}
              className="p-1.5 rounded-lg text-muted-foreground hover:bg-muted transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
              aria-label="Open navigation"
              data-testid="hamburger-menu"
            >
              <Menu className="h-5 w-5" />
            </button>
            <span className="text-sm font-semibold text-foreground">Revisr</span>
          </div>
        )}

        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
}

